import {createContext, useReducer} from "react";

const initData = {
    showModal: false,
    title: '',
    content: '',
    successMsg : '',
    errorMsg: ''
}
export const ModalContext = createContext(null);
export const ModalDispatch = createContext(null);
export const ModalProvider = ({children}) => {
    const [modalData, dispatch] = useReducer(
        ModalReducer,
        initData
    )
    return (
        <ModalContext.Provider value={modalData}>
            <ModalDispatch.Provider value={dispatch}>
                {children}
            </ModalDispatch.Provider>
        </ModalContext.Provider>
    )
}
function ModalReducer(modalData, action) {
    switch (action.type) {
        case "showModal":
            return {
                ...modalData,
                showModal: true
            };
        case "hideModal":
            return {
                ...modalData,
                showModal: false
            };
        case "setModalContent":
            return {
                ...modalData,
                title: action.payload.title,
                content: action.payload.content
            };
        case "setSuccessMsg":
            return {
                ...modalData,
                successMsg: action.payload
            };
        case "setErrorMsg":
            return {
                ...modalData,
                errorMsg: action.payload
            };
        case "clear":
            return {
                ...modalData,
                successMsg: '',
                errorMsg: ''
            };
        default:
            throw Error('Unknown action: ' + action.type);
    }
}